"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StitchCollectionBrowser_1 = __importDefault(require("./StitchCollectionBrowser"));

var StitchDatabaseBrowser =
/** @class */
function () {
  function StitchDatabaseBrowser(db) {
    this.db = db;
    this.name = this.db.name;
  }

  StitchDatabaseBrowser.prototype.collection = function (name) {
    return new StitchCollectionBrowser_1.default(this.db.collection(name));
  };

  return StitchDatabaseBrowser;
}();

exports.default = StitchDatabaseBrowser;